<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"></a> Copyright © 1996 by James Carroll<br/>
All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data</em><br/>
Carroll, James, date.<br/>
An American requiem : God, my father, and the war that came<br/>
between us / James Carroll,<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-77926-x<br/>
<span style="font-size: smaller">ISBN</span> 0-395-85993-x (pbk.)<br/>
1. Carroll, James, 1943–—Family. 2. Novelists—20th century—Family relationships. 3. Ex-priests, Catholic—United States—Family relationships. 4. Vietnamese Conflict, 1961–1975—Protest movements—United States. 5. Fathers and sons—United States—Biography. 6. Catholics—United States—Biography. I. Title.<br/>
<span style="font-size: smaller">PS</span>3553.<span style="font-size: smaller">A</span>764<span style="font-size: smaller">Z</span>464 1996 95-52125 <span style="font-size: smaller">CIP</span><br/>
813'.54—dc20</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-547-52454-2<br/>
v2.0114</p>
<p class="timebreak"> <br/></p>
<p class="center">The author is grateful for permission to quote from the following: Lines from “Vapor Trail Reflected in the Frog Pond,” from <em>Body Rags</em> by Galway Kinnell. Copyright © 1965, 1966, 1967 by Galway Kinnell. Reprinted by permission of Houghton Mifflin Company. All rights reserved. Lines from “Vietnamese,” from <em>Growing into Love</em> by X. J. Kennedy. Reprinted by permission of Curtis Brown Ltd. Copyright © 1969 by X. J. Kennedy. Lines from “Death of Little Boys” from <em>Poems: 1922–1947</em> by Allen Tate. Copyright 1931, 1932, 1937, 1948 Charles Scribner’s Sons; renewed copyright © 1959, 1960 Allen Tate.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?fbc78ebe